module.exports = __webpack_public_path__ + "img/about.fcf72df7.png";